<template>
  <div class="stat-card">
    <div class="card-label">{{ label }}</div>
    <div class="card-value">{{ value }}</div>
    <div v-if="sub" class="card-sub" :class="`trend-${trend}`">{{ sub }}</div>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  sub:   { type: String, default: null },
  trend: { type: String, default: "neutral" }, // positive | negative | warning | neutral
})
</script>

<style scoped>
.stat-card {
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 18px 20px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat-card:hover {
  background: rgba(245, 166, 35, 0.06);
  border-color: rgba(245, 166, 35, 0.18);
  transform: translateY(-2px);
}

.card-label {
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(232, 230, 227, 0.45);
}

.card-value {
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 700;
  color: #e8e6e3;
  margin-top: 8px;
}

.card-sub {
  font-family: var(--font-mono);
  font-size: 11px;
  margin-top: 6px;
}

.trend-positive { color: #4ade80; }
.trend-negative { color: #f87171; }
.trend-warning  { color: #fbbf24; }
.trend-neutral  { color: #f5a623; }
</style>
